<template>
  <vs-sidebar
    click-not-close
    position-right
    v-model="openAccountDialogShow"
    class="items-no-padding open-mt4-account-dialog sidebar-dialog"
  >
    <div class="sidebar-content h-full">
      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div>
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar
        class="scroll-area--customizer pt-4 pb-6"
        :settings="settings"
        :key="$vs.rtl"
      >
        <div class="content px-6">
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
          >
            <el-form-item
              prop="groupName"
            >
              <div
                v-for="(item,index) in groupListFilter"
                :key="index"
                @click="groupNameHandel(item.groupName)"
                class="type-item"
                :class="{
                  active: item.groupName == form.groupName,
              }"
              >
                <el-radio
                  v-model="form.groupName"
                  :label="item.groupName"
                >{{item.groupName}}</el-radio>
                <p class="detail-config"><span class="gray-text">{{$t('User.miniSpreads')}}</span>&nbsp;&nbsp;{{item.leastSpread}}</p>
                <p class="detail-config"><span class="gray-text">{{$t('User.leastDeposit')}}</span>&nbsp;&nbsp;{{item.leastDeposit}} USD</p>
                <p class="detail-config"><span class="gray-text">{{$t('User.leverageBest')}}</span>&nbsp;&nbsp;1:{{item.leverageMax}}</p>
              </div>
              <div
                v-if="openMockBtnShow"
                @click="groupNameHandel('demo')"
                class="type-item"
                :class="{
                         active: 'demo' == form.groupName,
                }"
              >
                <el-radio
                  v-model="form.groupName"
                  label="demo"
                >{{'Demo'}}</el-radio>
                <p class="detail-config"><span class="gray-text">{{$t('User.amount')}}</span>&nbsp;&nbsp;{{demoAmount}}</p>
              </div>
            </el-form-item>
            <el-form-item
              v-if="form.groupName != 'demo' && form.role"
              prop="role">
              <div class="self-label">
                <account-role-tips></account-role-tips>
              </div>
              <el-select
                style="width: 100%"
                v-model="form.role"
                :placeholder="$t('please_choose')"
              >
                <!--默认选普通的账户, copy则是点击哪个角色就哪个角色 todo-->
                <el-option
                  v-for="(item,index) in roleOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="form.groupName != 'demo'"
              prop="alias"
            >
              <div class="self-label">
<!--                style="width: 120px;"-->
                <p>
                  {{$t('Customer_nickname')}}
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div
                      class="tips-content"
                      slot="content"
                    >{{$t('Nicknames_cannot_be_changed_after_they_are_set')}}</div>
                    <i class="el-icon-info tips-icon"></i>
                  </el-tooltip>
                </p>

              </div>
              <el-input
                v-model="form.alias"
                maxlength="10"
                show-word-limit
                :placeholder="$t('Please_enter_a_nickname')"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="form.groupName != 'demo'"
              prop="lever"
            >
              <p class="lever-title">{{$t('User.leverage')}}
                <el-tooltip class="item" effect="dark" placement="top">
                <div class="tips-content" slot="content"
                     style="width: 233px;"
                >{{$t('openAccPageTips')}}</div>
                <i class="el-icon-info tips-icon"></i>
                </el-tooltip>
              </p>
              <el-select
                style="width: 100%"
                class="leverval el-select-self"
                v-model="form.lever"
                :placeholder="phFileter('User.selectLev')"
                :disabled="!openLeverage"
              >
                <el-option
                  v-for="(leverageListSelf, index) in leverageComputed"
                  :key="index"
                  :label="leverageListSelf.levName"
                  :value="leverageListSelf.lev"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </VuePerfectScrollbar>
    </div>
    <div
      class="footer-sidebar" slot="footer">
      <el-button
        @click="cancelHandle"
        type="text"
        class="calcel-btn"
      >{{$t('cancel')}}</el-button>
      <el-button
        @click="submitHandle"
        type="primary"
        :loading="loading"
      >{{$t('Confirm')}}</el-button>
    </div>
  </vs-sidebar>
</template>

<script>
import { setBodyHidden,setBodyNormal } from "@/utils/common";
import { getMt4Group, openMT4Acc, openMockMt4, mtAccList,queryAccountLimit } from '@/api/userCenter.js';

import { mapGetters } from 'vuex'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import accountRoleTips from '@/components/public/accountRoleTips'
export default {
  name: "openMt4AccountDialog",
  props: {
  },
  components:{
    VuePerfectScrollbar,
    accountRoleTips,
  },
  data() {
    let _this = this;
    return {
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      openLeverage: true, // 允许调整杠杆
      openMockBtnShow: true,
      title: _this.$t('add_account'),
      roleOptions: [
        // {label: _this.$t('Ordinary_account'), value: 1},
        {label: _this.$t('MAM_master_account'), value: 4},
        {label: _this.$t('MAM_Investment_Account'), value: 5},
        /*{label: _this.$t('Social_master_account'), value: 2},
        {label: _this.$t('Social_Investment_Account'), value: 3},*/
      ],
      groupList:[],
      leverListstd: [],
      leverListpro: [],
      leverListecn: [],
      leverListcent: [],
      leverListstp: [],
      // 接口重新对接 todo
      tradeVal: 1,
      form: {
        role: '', // 默认普通账号
        groupName: 'PRO',// 默认是选中PRO
        alias: '',
        lever: '',
      },
      rules: {
        role: [
          { required: true, message: _this.$t('please_choose'),trigger: 'change' }
        ],
        groupName: [
          { required: true, message: _this.$t('Please_select_account_type'),trigger: 'change' }
        ],
        alias: [
          { required: true, message: _this.$t('Please_enter_a_nickname'),trigger: 'blur' }
        ],
        lever: [
          { required: true, message: _this.$t('User.selectLev'),trigger: 'change' },
        ],
      },
      loading: false,
      demoAmount: '$10000',
      centAccountCount: 0,
    }
  },
  watch: {
    openAccountDialogShow(val){
      this.$refs.form && this.$refs.form.resetFields();
      this.$refs.form && this.$refs.form.clearValidate();
      if(val){
        setBodyHidden();
        if(this.userInfo.id){
          this.getIsHasMockAcc();
          this.getMt4Group();
          this.reset();
          if(this.openAccountRole){
            this.form.role = this.openAccountRole;
          }
        }
      }else {
        setBodyNormal();
        this.$store.commit('setOpenAccountRole', '');
      }
    },
    openAccountRole(val){
      if(val){
        this.form.role = val;
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo','listRefresh','openAccountDialogShow','openAccountRole']),
    leverageComputed(){
      switch (this.form.groupName) {
        case 'STD':
          return this.leverListstd;
        case 'PRO':
          return this.leverListpro;
        case 'ECN':
          return this.leverListecn;
        case "Cent":
          return this.leverListcent;
        case "STP":
          return this.leverListstp;
      }
    },
    groupListFilter(){
      if(!this.groupList.length){
        return [];
      }else {
        if(this.centAccountCount && !this.form.role){
          return this.groupList;
        }else {
          let arr = this.groupList.filter((item) => {
            return item.groupName != 'Cent';
          });
          return arr;
        }
      }
    }
  },
  methods: {
    getIsHasMockAcc() {
      let mtAccListData = {
        id: this.userInfo.id,
        businessTypes: 5,
      };
      mtAccList(mtAccListData).then((res) => {
        if (res.data.length) {
          this.openMockBtnShow = false;
        } else {
          this.openMockBtnShow = true;
        }
      });
    },
    queryAccountCount(){
      queryAccountLimit({
        custId: this.userInfo.id,
      }).then((res) => {
        this.centAccountCount = res.data.centAccountLimit;
        this.openLeverage = res.data.openLeverage;
      })
    },
    reset(){
      this.form.role = '';
      this.form.groupName = 'PRO';
      this.form.lever = '';
      this.form.alias = '';
      this.$refs.form && this.$refs.form.clearValidate();
    },
    setLeverage(leverageList) {
      let levList = leverageList.split(',');
      let tempList = [];
      for (let i = 0; i < levList.length; i++) {
        let lev = parseInt(levList[i]);
        let levName = '1:' + levList[i];
        let params = {
          levName: levName,
          lev: lev
        };
        tempList[i] = params;
      }
      return tempList;
    },
    getMt4Group() {
      getMt4Group({
        isMock: 2
      }).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].accType === 'STD') {
            res.data[i].sort = 1;
            this.leverListstd = this.setLeverage(res.data[i].leverageList);
          } else if (res.data[i].accType === 'PRO') {
            res.data[i].sort = 2;
            this.leverListpro = this.setLeverage(res.data[i].leverageList);
          } else if (res.data[i].accType === 'ECN') {
            res.data[i].sort = 4;
            this.leverListecn = this.setLeverage(res.data[i].leverageList);
          }else if (res.data[i].accType === 'Cent') {
            res.data[i].sort = 5;
            this.leverListcent = this.setLeverage(res.data[i].leverageList);
          }else if (res.data[i].accType === 'STP') {
            res.data[i].sort = 3;//放pro后面
            this.leverListstp = this.setLeverage(res.data[i].leverageList);
          }
        }
        res.data.sort((itemA,itemB) => {
          return itemA.sort - itemB.sort;
        })
        this.groupList = res.data;
        this.queryAccountCount();
      });
    },
    phFileter(data) {
      return this.$t(data);
    },
    openMockHandle(){
      this.loading = true;
      openMockMt4({
        custId: this.userInfo.id
      }).then((res) => {
        this.loading = false;
        this.$message({
          message: this.$t('mockOpenSuccessTip'),
          type: 'success'
        });
        this.$store.commit('setListRefresh',!this.listRefresh);
        this.openMockBtnShow = false;
        this.form.groupName = 'PRO';
        this.close();
      }).catch((error) => {
        this.loading = false;
      });
    },
    groupNameHandel(groupName){
      this.form.groupName =  groupName;
      // 杠杆重置到所选组的第一个,排除demo
      if(this.form.groupName != 'demo'){
        this.form.lever = this.leverageComputed[0].lev;
      }
    },
    close(){
      this.$store.commit('setOpenAccountDialogShow', false);
    },
    closeHandle() {
      this.$refs.form && this.$refs.form.resetFields();
      this.$refs.form && this.$refs.form.clearValidate();
      this.close();
    },
    interfaceAjaxSuccess(){
      this.$message({
        message: this.$t('User.custStatus2'),
        type: 'success'
      });
      this.$store.commit('setListRefresh',!this.listRefresh);
      this.close();
    },
    submitHandle(){
      if(this.form.groupName == 'demo'){
        this.openMockHandle();
      }else {
        this.$refs.form.validate((valid) => {
          if(valid){

            let openAccData = {
              tradePlatform: this.tradeVal,
              custId: this.userInfo.id,
              accountType: !this.form.role ? 1: this.form.role, //默认1
              alias: this.form.alias,
              leverage: this.form.lever,
              group: this.form.groupName,
            };
            if(this.form.groupName == 'Cent'){
              openAccData.depCurrency = 'USC';
            }else {
              openAccData.depCurrency = 'USD';
            }
            this.loading = true;
            openMT4Acc(openAccData).then((res) => {
              this.loading = false;
              this.interfaceAjaxSuccess();
            }).catch((error) => {
              this.loading = false;
              this.close();
            });

          }else {
            console.log('error');
          }
        })
      }
    },
    cancelHandle(){
      this.close();
    }
  },
}
</script>
<style lang="scss">
@import "../../assets/scss/variable";
.open-mt4-account-dialog {
  .content {
    padding-top: 20px;
    .tab-inner {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 20px;
      .tab-item {
        padding: 5px;
        padding-left: 10px;
        padding-right: 10px;
        border: 1px solid $themeColor;
        cursor: pointer;
        color: $themeColor;
        &:first-child {
          border-bottom-left-radius: 10px;
          border-top-left-radius: 10px;
        }
        &:last-child {
          border-left: none;
          border-bottom-right-radius: 10px;
          border-top-right-radius: 10px;
        }
      }
    }
  }
  .self-label {
    line-height: 20px;
  }
  .type-item {
    border: 1px solid #D8D6DE;
    border-radius: 10px;
    padding-left: 10px;
    padding-bottom: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    &.active {
      border-color: $themeColor;
    }
    .detail-config {
      line-height: normal;
      padding-left: 20px;
    }
  }
}
</style>
<style lang="scss">
.open-mt4-account-dialog {
  .vs-sidebar-position-right {
    z-index: 999999;
  }
  .vs-sidebar--items {

  }
  .vs-sidebar {
    position: fixed;
    z-index: 1002;
    .sidebar-content {
    }
  }
  // sidebar弹框的遮罩层
  .vs-sidebar--background {
    z-index: 1001!important;
  }
  .top-line {
    text-align: right;
    margin-bottom: 10px;
  }
  .gray-text {
    color: #A29FAE;
  }
  .scroll-area--customizer {
    height: calc(100% - 5rem);
  }
  .footer-sidebar {
    padding: 20px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 20px;
    .calcel-btn {
      margin-right: 10px;
    }
  }
}
</style>
